import { MeurhArquivosEmpresaService } from '../arquivos.empresa.service';
import { MeurhVisualizarArquivoModalService } from '../../modal/visualizararquivo/visualizararquivo.modal.service';
import { IArquivoEmpresa, IPastaEmpresa } from '../../model/arquivos.empresa.model';

export class MeurhArquivosEmpresaIndexController {
    static $inject = [
        '$rootScope',
        '$state',
        'MeurhArquivosEmpresaService',
        'MeurhVisualizarArquivoModalService'
    ];

    public pastas: IPastaEmpresa[] = [];
    public pastaAtual: IPastaEmpresa;
    public arquivos: (IArquivoEmpresa & {selecionado?: boolean })[]  = [];
    public busy = false;
    public loading = {
        pastas: false,
        arquivos: false
    };
    public filters: {
        competenciames: string,
        competenciaano: number | null
    };
    public filter: {
        competenciames?: number,
        competenciaano?: number
    } = {};

    constructor(
        public $rootScope: angular.IRootScopeService & {
            soPossuiPonto: () => boolean,
            temPermissao: (arg: string) => boolean,
            liberadoTela: (param: string) => boolean,
        },
        public $state: angular.ui.IStateService,
        public MeurhArquivosEmpresaService: MeurhArquivosEmpresaService,
        public MeurhVisualizarArquivoModalService: MeurhVisualizarArquivoModalService
    ) {
        if (!(!$rootScope.soPossuiPonto() &&
            $rootScope.liberadoTela('LIBERAR_ARQUIVO_EMPRESA') &&
            $rootScope.temPermissao('visualizar_arquivos_empresa'))
        ) {
            $state.go('dp');
        }

        this.getPastas();
    }

    getPastas() {
        this.loading.pastas = true;
        this.MeurhArquivosEmpresaService.getPastas().then((result) => {
            this.pastas = result;
        }).finally(() => this.loading.pastas = false);
    }

    getArquivos(pasta: IPastaEmpresa) {
        this.pastaAtual = pasta;
        this.arquivos = [];
        this.loading.arquivos = true;
        this.MeurhArquivosEmpresaService.getArquivos(pasta.tipoarquivoempresa)
            .then((result) => {
                this.arquivos = result;
            }).finally(() => this.loading.arquivos = false);
    }

    setFilter() {
        this.filter = {
            ...((this.filters.competenciames && this.filters.competenciames !== '') && {
                competenciames: parseInt(this.filters.competenciames, 10)
            }),
            ...((this.filters.competenciaano) && {
                competenciaano: this.filters.competenciaano
            }),
        };
    }

    visualizarArquivo(id: string, extensao: string) {
        const modal = this.MeurhVisualizarArquivoModalService.open(
            id,
            extensao,
            this.MeurhArquivosEmpresaService
        );
        modal.result
            .then(() => {/* */})
            .catch((error) => {
                console.log(error);
            });
    }

    downloadArquivos(arquivo: IArquivoEmpresa) {
        const arquivosSelecionados = arquivo ? [arquivo] : this.arquivos.filter(arquivo => arquivo.selecionado);
        this.busy = true;
        if (arquivosSelecionados.length === 1) {
            this.MeurhArquivosEmpresaService.getConteudo(arquivosSelecionados[0].arquivoempresa)
            .then((response) => {
                this.handleDownload(response.data, arquivosSelecionados[0].nome, 'application/octet-stream');
            }).finally(() => this.busy = false);
        } else {
            const param = (!arquivosSelecionados.length ? this.arquivos : arquivosSelecionados)
            .map((arq) => ({ arquivoempresa: arq.arquivoempresa }));

            this.MeurhArquivosEmpresaService.downloadArquivos(param)
            .then((result) => {
                this.handleDownload(result, 'arquivos.zip');
            }).finally(() => this.busy = false);
        }
    }

    private handleDownload(file: File, name: string, type?: string) {
        const blob = new Blob([file], { type });
        const fileURL = URL.createObjectURL(blob);
        const a = document.createElement('a');

        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = fileURL;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(fileURL);
    }
}
